import * as angular from 'angular';

"use strict";

angular.module('RolesAndPermissionsModule', [])

export default 'RolesAndPermissionsModule';
